import { RegionsPage } from 'pageModules/RegionsPage';

export default RegionsPage;
